var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid-panel" }, [
    _vm.panelHeader
      ? _c("div", { staticClass: "grid-panel-header" }, [
          _c("span", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm.panelHeader,
                expression: "panelHeader",
              },
            ],
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.panelTitle
      ? _c("div", {
          directives: [
            {
              name: "dompurify-html",
              rawName: "v-dompurify-html",
              value: _vm.panelTitle,
              expression: "panelTitle",
            },
          ],
          staticClass: "panel-title",
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-container" },
      [
        _c(
          "v-overlay",
          {
            attrs: {
              absolute: "",
              opacity: "1",
              value: _vm.loading,
              color: "var(--panel-background)",
            },
          },
          [
            _c("v-progress-circular", {
              attrs: {
                indeterminate: "",
                color: "var(--primary-btn-bg-color)",
                size: "32",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }